import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-ticket-filter-sidebar',
  imports: [SharedModule],
  templateUrl: './ticket-filter-sidebar.component.html',
  styleUrl: './ticket-filter-sidebar.component.scss'
})
export class TicketFilterSidebarComponent {

  @Input() visible: boolean = true;
  @Input() filterLoading: boolean = false;

  @Output() removeFilter = new EventEmitter<void>();

 conditionOptions = [
    { label: 'With', value: 'with' },
    { label: 'Without', value: 'without' }
  ];

  filters = {
    owner_assigned: { checked: false, condition: 'with' },
    ticket_activity: { checked: false, condition: 'with' },
    attachment: { checked: false, condition: 'with' }
  };

  @Output() filtersApplied = new EventEmitter<any>();

  applyFilters() {
    const payload = this.filters;
    this.filtersApplied.emit(payload);
  }

  clearFilters() {
    this.filters = {
      owner_assigned: { checked: false, condition: 'with' },
      ticket_activity: { checked: false, condition: 'with' },
      attachment: { checked: false, condition: 'with' }
    };
    this.removeFilter.emit(); // Emit an event to notify that filters have been cleared
  }


}
